import { ref as s, computed as V, resolveComponent as i, openBlock as g, createElementBlock as M, Fragment as x, createVNode as m, mergeProps as k, withCtx as c, createElementVNode as v, normalizeStyle as B, createTextVNode as F, createBlock as h, Teleport as y } from "vue";
import { onClickOutside as b } from "./design-system.es125.js";
import _ from "./design-system.es171.js";
import z from "./design-system.es49.js";
import P from "./design-system.es65.js";
/* empty css                    */
import S from "./design-system.es128.js";
import I from "./design-system.es69.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import U from "./design-system.es37.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { usePopper as D } from "./design-system.es119.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const N = {
  name: "DsColorField",
  components: {
    ColorPicker: z,
    InputField: P,
    MenuContainer: I,
    Box: U
  },
  props: {
    /**
     * Hex value of the color field
     */
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(p, { emit: e }) {
    const t = s(!1), o = s(null), n = s(null), f = "/^#?([a-fA-F0-9]{6})$/";
    function a() {
      t.value = !0;
    }
    function l() {
      t.value = !1;
    }
    function d(r) {
      const C = _(r);
      C.isValid() && e("update:modelValue", C.toHexString().toUpperCase());
    }
    const u = V(() => {
      const r = _(p.modelValue);
      return r.isValid() ? r.toHexString().toUpperCase() : "#000000";
    });
    return D({
      trigger: o,
      menu: n,
      isOpen: t,
      position: "bottom-start"
    }), b(
      n,
      l,
      { ignore: [o] }
    ), {
      trigger: o,
      menu: n,
      isOpen: t,
      pattern: f,
      openMenu: a,
      closeMenu: l,
      handleColorChange: d,
      normalizedModelValue: u
    };
  }
};
function O(p, e, t, o, n, f) {
  const a = i("InputField"), l = i("ColorPicker"), d = i("Box"), u = i("MenuContainer");
  return g(), M(x, null, [
    m(a, k({ ref: "trigger" }, p.$attrs, {
      class: "ds-color-field",
      "model-value": o.normalizedModelValue,
      maxlength: 7,
      pattern: o.pattern,
      onClick: o.openMenu,
      onBlur: e[0] || (e[0] = (r) => o.handleColorChange(r.target.value))
    }), {
      leading: c(() => [
        v("div", {
          class: "ds-color-field-trigger",
          style: B({ "background-color": o.normalizedModelValue })
        }, null, 4)
      ]),
      _: 1
    }, 16, ["model-value", "pattern", "onClick"]),
    e[1] || (e[1] = F()),
    (g(), h(y, { to: "body" }, [
      m(u, {
        ref: "menu",
        "is-open": o.isOpen,
        style: { "--ds-menu-container-width": "15.625rem" },
        onClose: o.closeMenu
      }, {
        default: c(() => [
          m(d, { padding: "spacing-100" }, {
            default: c(() => [
              m(l, {
                "model-value": o.normalizedModelValue,
                "onUpdate:modelValue": o.handleColorChange
              }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "onClose"])
    ]))
  ], 64);
}
const ko = /* @__PURE__ */ S(N, [["render", O], ["__scopeId", "data-v-5799b05b"]]);
export {
  ko as default
};
//# sourceMappingURL=design-system.es48.js.map
